/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

var GetEntity = require('../services/GetEntity');
var GetEntityLegalHoldStatus = require('../services/GetEntityLegalHoldStatus');
var GetEntityFlaggedStatus = require('../services/GetEntityFlaggedStatus');
var GetInternalTasksByEntity = require('../services/GetInternalTasksByEntity');

var NonDepEntityDashboardView = require('../views/NonDepEntityDashboardView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(
    GetEntity(entityId),
    GetEntityIdentifiers(entityId),
    GetInternalTasksByEntity(entityId),
    GetEntityLegalHoldStatus(entityId),
    GetEntityFlaggedStatus(entityId)
  )
    .done(function(entity, entityIdentifiers, internalTasks, hasLegalHold, hasFlagged) {
      NavUtils.navigate('nondep/entity/' + entityId + '/dashboard');
      Scaffold.content.show(
        new NonDepEntityDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({
            entity: entity,
            entityIdentifiers: entityIdentifiers,
            tasks: internalTasks,
            hasLegalHold: hasLegalHold,
            hasFlagged: hasFlagged
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
